import { render, staticRenderFns } from "./AccountWarning.vue?vue&type=template&id=6e539686"
import script from "./AccountWarning.vue?vue&type=script&lang=js"
export * from "./AccountWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports